module.exports = __webpack_public_path__ + "img/17.48dd0647.jpg";